import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_antd@3.1.1@antd/es/col/index.js
// module id = null
// module chunks = 